import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { remove } from '../redux/actions/loader.action';

/**
 * Кастомный хук для обработки успешного завершения запроса:
 * - сбрасывает данные формы
 * - закрывает модальное окно
 * - закрывает окно подтверждения в случае ошибки
 * - удаляет флаг загрузки при размонтировании
 *
 * @param {function} setFormData - Функция для сброса состояния формы
 * @param {object} initialFormData - Исходное состояние формы
 * @param {function} closeModal - Функция для закрытия основного модального окна
 * @param {function} closeStatusEditModal - Функция для закрытия окна подтверждения
 */
const useSuccessListener = (setFormData, initialFormData, closeModal, closeStatusEditModal) => {
  const loader = useSelector((state) => state.loader);
  const error = useSelector((state) => state.error);

  const dispatch = useDispatch();

  useEffect(() => {
    const isFinished = !loader?.isLoading && loader?.isSuccess;

    // Если запрос завершён успешно
    if (isFinished && setFormData && initialFormData && closeModal) {
      // Сбрасываем данные формы
      setFormData(initialFormData);
      // закрытие модалки
      closeModal();
    }
    // Если произошла ошибка — закрываем только окно подтверждения
    if ((error || error?.error) && closeStatusEditModal) {
      closeStatusEditModal();
    }

    // При размонтировании компонента — сбрасываем состояние загрузки
    return () => {
      if (isFinished) {
        dispatch(remove());
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loader?.isLoading, loader?.isSuccess, error]);
};

export default useSuccessListener;
